<!--suppress CheckEmptyScriptTag -->
<template>
  <q-dialog
    persistent
    :maximized="$q.screen.lt.sm"
    :value="isOpen" >
    <q-card style="max-width:900px">
      <q-btn round flat size="lg" icon="close" color="red" class="float-right" style="float:right;z-index: 9999" @click="hide" />
      <div class="text-h4 q-pa-sm text-center" style="position:relative;padding-left:50px;z-index: 1">Checkout</div>
    <div>
    <div >
            <q-stepper v-model="step" vertical color="primary" done-color="green" animated flat class="full-width " >
            <q-step :name="1" title="Login or Register" icon="" :done="step > 1" v-if="showStepOne">
                <div class="row" >
                    <div class="login col-xs-12 col-sm-6">
                        <div class="text-center text-h5">Sign In</div>
                        <login-open v-model="details"/>
                    </div>


                    <div class="register col-xs-12 col-sm-6">
                        <div class="text-center text-h5">No Account? No Problem.</div>
                        <div style="margin-top:30px">You can create an account during the checkout process.</div>
                        <div style="display: flex;  justify-content: center;  align-items: center;" >
                            <q-stepper-navigation><q-btn @click="step2" color="primary" label="Continue"></q-btn></q-stepper-navigation>
                        </div>
                    </div>
                </div>
            </q-step>

            <q-step style="z-index:0; overflow:hidden" :name="2" title="Details" icon="none" :done="step > 2">
              <div style="margin-left:-40px;">
                <shipping-details v-model="details" ref="shippingDetails"/>
                <q-stepper-navigation>
                <q-btn @click="validateShippingForm" color="primary" label="Continue"></q-btn>
                <q-btn flat @click="step = 1" color="primary" label="Back" class="q-ml-sm" v-if="!isLoggedIn"></q-btn>
                </q-stepper-navigation>
              </div>
            </q-step>

            <q-step :name="3" title="Payment Details" icon="" :done="step > 3">
              <div style="margin-left:-40px;" :style="disableContent" >
                    <div class="col-12">
                      <div class="text-bold">Discount</div>
                        <q-input dense outlined label="Voucher Code" v-model="voucherCode" :rules="[ applyVoucher ]" debounce="1000" clearable>
                      </q-input>
                    </div>
                    <div class="col-12 text-center text-h5" style="padding-bottom: 5px;text-decoration: underline; margin-bottom: 10px">
                      Order Summary
                    </div>
                    <div class="col-12">
                      <span class="text-bold">Subtotal:</span><span style="float: right">AUD$ ${{ Number(newitemsCost).toFixed(2) }}</span>
                    </div>
                    <div class="col-12" v-if="voucherDiscount">
                      <span class="text-bold">└ Discount:</span><span style="float: right">AUD$ -${{Number(voucherDiscount).toFixed(2)}}</span>
                    </div>                     
                    <div class="col-12">
                      <div v-if="holdsShippingCost > 0 && homeWallQty == 0">
                        <span class="text-bold">Shipping:</span><span style="float: right">AUD$ ${{ Number(shippingCost).toFixed(2) }}</span><br>
                      </div>
                      <div v-if="holdsQty > 0 && homeWallQty > 0">
                        <span class="text-bold">Holds Shipping:</span><span style="float: right">AUD$ ${{ Number(holdsShippingCost).toFixed(2) }}</span><br> 
                      </div>
                      <div v-if="homeWallQty > 0">
                        <span class="text-bold">Home Wall Shipping to {{details.shippingDetails.postCode}}:</span><span style="float: right">AUD$ ${{ Number(homeWallShippingCost).toFixed(2) }}</span>
                      </div>                                     
                      <div v-if="Number(newitemsCost).toFixed(2) === Number(voucherDiscount).toFixed(2) && isFullDiscount">
                      <span class="text-bold">└ Discount:</span><span style="float: right">AUD$ -${{Number(shippingCost).toFixed(2)}}</span><br>
                      <span class="text-bold">Process Fee*:</span><span style="float: right">AUD$ $ 1.00</span><br><br>
                      <span class="text-italics">*The process fee is refundable.<br>Refunds take 5-10 days to appear on your statement. </span><br>
                      </div>
                    </div>                   
                    <div class="col-12 text-bold" style="font-size: 18px; border-top: 2px dashed silver; margin:10px 0 0 0;padding: 10px 0 0 0">
                      <span class="text-bold">Total:</span><span style="float: right">AUD$ {{ Number(totalCostWithDiscount).toFixed(2) }}</span>
                    </div>         
                    <div class="col-12" style="padding-bottom: 20px">
                      <span>Includes GST:</span><span style="float: right">AUD$ {{ Number(totalCostWithDiscount*(1-1/1.1)).toFixed(2) }}  </span>
                    </div>        

        

                <div class="full-width" style="display: flex; justify-content:center">
                    <div class="row" v-bind:style="{ visibility: showStripe}" style="position:relative;">
                      <label for="cardNumber-element" class="col-12">
                        Card Number
                      </label>
                        <div id="cardNumber-element" class="col-12 full-width cc-number"></div>
                        <font-awesome-icon style="position:absolute; padding:3px; top:19; left:10 ;color:grey;" :icon="cardIcon" id="brand-icon" size="3x"/>
                      <label style="margin-top:20px;" for="cardExpiryDate-element" class="col-5" v-if="!initialLoading">
                        Expiry Date
                      </label>
                      <div class="col-2"></div>
                      <label style="margin-top:20px;" for="cardCVC-element" class="col-5" v-if="!initialLoading">
                        Security Code
                      </label>                    
                      <div id="cardExpiryDate-element" class="col-5 cc-date"></div>
                      <div class="col-2"></div>
                      <div id="cardCVC-element" class="col-5 cc-code"></div>
                      <div class="col-12 text-red text-bold q-mt-lg">
                          {{errorMessage}}
                      </div>                    
                    </div>
                </div>
              </div>
              <div style="margin-left:-40px; border: solid 2px #C5161C; background-color:#f9ecee; padding: 10px" v-if="showContactSale"> 
                <p>We can't calculate the shipping rate for your area at the moment.</p>
                <p>Please contact our sales representative: <a href="https://climbicp.com.au/contact-new"> Contact Us</a></p>
              </div>
              <div style="margin-left:-40px; border: solid 2px #C5161C; background-color:#f9ecee; padding: 10px" v-if="showShippingError"> 
                <p>We couldn't match your postcode. Is <b>{{details.shippingDetails.postCode}}</b> correct?</p>
                <p>Please go back and try again or contact our sales representative: </p>
                  <a href="https://climbicp.com.au/contact-new"> Contact Us</a>
              </div>              
              <div style="margin-left:-40px;">
                <q-stepper-navigation>
                <q-btn color="primary" :disabled="isProcessing"  @click="pay" :style="hidePayButton">Pay ${{Number(totalCostWithDiscount).toFixed(2)}} </q-btn>
                <q-btn flat @click="backTo2" color="primary" label="Back" class="q-ml-sm"></q-btn>
                </q-stepper-navigation>
                <q-inner-loading :showing="initialLoading">
                  <q-spinner-gears color="primary" size="4em"/>
                </q-inner-loading>
              </div>
            </q-step>
            </q-stepper>
      </div>
    </div>



    </q-card>
  </q-dialog>
</template>

<script>
import gql from 'graphql-tag'
import store from '../store'
import ShippingDetails from './ui/NewShippingDetails'
import LoginOpen from '../views/LoginOpen'
import { onLogin } from '../apollo/auth'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner, faAlignLeft,faAddressCard, faCreditCard} from '@fortawesome/free-solid-svg-icons'

library.add(faSpinner, faAlignLeft, faAddressCard, faCreditCard, fab)



// eslint-disable-next-line no-undef
const stripe = Stripe(store.state.auth.stripePublishableKey)

const elements = stripe.elements({
  fonts: [{
    cssSrc: 'https://fonts.googleapis.com/css?family=Raleway&display=swap'
  }]
})


export default {
  name: 'StripeDialog',
  components: { LoginOpen,ShippingDetails },
  props: ['holdsQty','holdsTotalCost','homeWallTotalCost','homeWallQty','holdsShippingCost','cartId', 'currentCart','calculateShipping','itemsCost', 'shippingCost', 'totalCost', 'apollo'],
  data () {
    return {
      details:{
        registrationDetails:{},
        shippingDetails:{}
      },
      step: 1,
      isOpen: false,
      isFormValid: false,
      isProcessing: false,
      initialLoading: true,
      stripe: null,
      card: null,
      errorMessage: null,
      voucherCode: '',
      voucherDiscount: 0,
      showStepOne: true,
      cardNumber:null,
      cardExpiryDate:null,
      cardCVC:null,
      cardIcon: 'credit-card',
      notLoaded: true,
      showStripe: "hidden",
      homeWallShippingCost:0,
      newitemsCost: this.homeWallTotalCost + this.holdsTotalCost,
      showContactSale: false,
      showShippingError: false,
      hidePayButton:'',
      disableContent:''
    }
  },
  computed: {
    isLoggedIn (){ 
      if(!!this.currentAccount){
        if(this.step == 1){
          this.step = 2;
        }
        this.showStepOne = false;
        return true
      }else{
        return false
      }
    },
    currentUUID () {
      return store.state.auth.currentUUID
    },
    currentAccount () {      
      return store.state.auth.currentAccount
    },
    isFullDiscount(){
      return this.voucherCode.includes("BXEN_");
    },
    totalCostWithDiscount () {
      if(Number(this.newitemsCost).toFixed(2) === Number(this.voucherDiscount).toFixed(2) && this.voucherCode.includes("BXEN_")){
        return 1;
      }else{
        if(this.holdsQty == 0){
          this.holdsShippingCost = 0;
        }

        return (this.newitemsCost - this.voucherDiscount) + this.holdsShippingCost + this.homeWallShippingCost
      }
    },
    voucherInvalid () {
      return !!this.voucherCode && !this.voucherDiscount
    },
    
  },
  methods: {
    async calculateShippingByPostcode(){
      this.homeWallShippingCost = 0;
      let homewallShippingCost = await this.getShippingCost_query(this.details.shippingDetails.postCode)
      if(homewallShippingCost ==  null){
        this.showShippingError = true
        this.disableContent = 'pointer-events: none;opacity: 0.4;';
        this.hidePayButton = "display:none"
        this.isProcessing = true
      } else if(homewallShippingCost.isPOA){
        this.disableContent = 'pointer-events: none;opacity: 0.4;';
        this.showContactSale = true
        this.hidePayButton = "display:none"
        this.isProcessing = true
      } else{
        
        this.homeWallShippingCost = homewallShippingCost.price * this.homeWallQty;
      }
    },    
    toHide(){
      if(this.isProcessing) return true;
    },
    step2 (){
      this.step = 2 ;
      this.showStepOne = false;
    },
    show () {
      this.isOpen = true
    },
    hide () {
      this.isOpen = false
      // this.onDialogHide()
      analytics.track('Checkout Popup Closed')
    }, 
    onDialogHide () {
      try{
        this.cardNumber.destroy()
        this.cardExpiryDate.destroy()
        this.cardCVC.destroy()
        // required to be emitted
        // when QDialog emits "hide" event
        this.$emit('hide')
      }catch(e){}
    },
    backTo2 (){
      this.cardNumber.destroy()
      this.cardExpiryDate.destroy()
      this.cardCVC.destroy()
      this.isFormValid = false
      this.step = 2
    },
    startProcessing () {
      this.isProcessing = true
      analytics.track('Retail Payment Process Started')
    },
    finishProcessing () {
      this.isProcessing = false
      analytics.track('Retail Payment Process Finished')

    },
    showError (errorMessage) {
      this.errorMessage = errorMessage
      this.finishProcessing()
      analytics.track('Checkout Process Error',{error:errorMessage})
    },
    async getShippingCost_query(postcode){
      try {
        const result = await this.apollo.query({
          query: gql`query shippingPriceData($postcode: String!){
            shippingPriceData (postcode: $postcode) {
              id
              suburb
              postcode
              state
              custZone
              driverZone
              depotRate
              secondaryRate
              price
              isPOA
            }
          }
        `,
        variables: {
          postcode: postcode
        },        
        fetchPolicy: 'network-only'
        })        
        return result.data.shippingPriceData;
      } catch (error) {
        throw new Error(error);    
      }         
    },    
    async applyVoucher () {
      if (this.voucherCode == null || this.voucherCode === '') {
        this.voucherDiscount = 0
        return true
      }
      try {
        let response = await this.apollo.query({
          query: gql`
            query voucherDiscountOnCart($cartId: ID!, $voucherCode: String!) {
              voucherDiscountOnCart(voucherCode: $voucherCode, cartId: $cartId)
            }
          `,
          variables: {
            cartId: this.cartId,
            voucherCode: this.voucherCode
          },
          context: {
            headers: {
              uuid: this.currentUUID
            }
          }          
        })
        this.voucherDiscount = response.data.voucherDiscountOnCart
        
        return true
      } catch (ex) {
        this.voucherDiscount = 0
        if (ex.graphQLErrors && ex.graphQLErrors.length > 0) {
          return ex.graphQLErrors[0].message
        }
        return ex.message
      }
    },
    clearError () {
      this.errorMessage = ''
    },
    changeIcon (brand) {
      var cardBrandToPfClass = {
        'visa': ['fab','cc-visa'],
        'mastercard':  ['fab','cc-mastercard'],
        'amex': ['fab','cc-amex'],
        'discover': ['fab','cc-discover'],
        'diners': ['fab','cc-diners-club'],
        'jcb': ['fab','cc-jcb'],
        'unknown': 'credit-card'
      }
      if (brand in cardBrandToPfClass) {
        this.cardIcon = cardBrandToPfClass[brand];
      }
    },
    async orderComplete (clientSecret, orderId) {
      this.isOpen = false
      this.$emit('ok', {
        orderId
      })
      analytics.track('Retail Order Completed')
      this.finishProcessing()
    },
    async timeout(ms){
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async validateShippingForm () {
      let valid = await this.$refs.shippingDetails.validate();
      this.isFormValid = valid;

      if(valid){
        this.step = 3;
        await this.loadCCIF()
        this.cardNumber.mount('#cardNumber-element')
        this.cardExpiryDate.mount('#cardExpiryDate-element')
        this.cardCVC.mount('#cardCVC-element')
        this.cardCVC.on('ready', () => {
          this.initialLoading = false;
          this.showStripe = "";
        })
        this.cardNumber.on('change', (event) => {     
          if (event.brand) {
            this.changeIcon(event.brand);
          }
        },);
        this.homeWallShippingCost = 0;
        this.showContactSale = false;
        this.showShippingError = false;
        this.disableContent = '',
        this.hidePayButton = '',
        this.isProcessing =  false;
        await this.calculateShippingByPostcode()
      }
    },
    loadCCIF (){
      this.cardNumber = elements.create('cardNumber', {
        style: {
          base: {
            color: '#32325d',
            lineHeight: '24px',
            fontFamily: 'Raleway, sans-serif',
            fontSize: '18px',
            '::placeholder': {
              color: '#aab7c4'
            },
            textAlign:'center'
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      });

      this.cardExpiryDate = elements.create('cardExpiry', {
        style: {
          base: {
            color: '#32325d',
            lineHeight: '24px',
            fontFamily: 'Raleway, sans-serif',
            fontSize: '18px',
            textAlign:'center',            
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      });

      this.cardCVC = elements.create('cardCvc', {
        style: {
          base: {
            color: '#32325d',
            lineHeight: '24px',
            fontFamily: 'Raleway, sans-serif',
            fontSize: '18px',
            textAlign:'center',
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        }
      });
    },
    async register (loginFormData) {
      loginFormData.activeRetailCartId = this.cartId
      try {
        const result = await this.apollo.mutate({
          mutation: gql`
            mutation ($input: RegisterRetailAccountInput!) {
              registerRetail(input: $input)
          }`,
          variables: {
            input: loginFormData
          }
        })
    
        const token = result.data.registerRetail
        await onLogin(this.apollo, token)
        await store.dispatch('auth/init')

        analytics.track('Login')
            
      } catch (err) {
        // if (err.networkError) {
        //   this.setFormError('Could not contact server')
        // } else if (err.graphQLErrors && err.graphQLErrors.length) {
        //   this.setFormError(err.graphQLErrors[0].message)
        // } else {
        //   this.setFormError('Error')
        // }
      }
    },
    async handleAction (clientSecret) {
      const data = await stripe.handleCardAction(clientSecret)
      if (data.error) {
        this.initialLoading = false;
        this.showStripe = "";
        this.showError('Your card was not authenticated, please try again')
        return
      }

      if (data.paymentIntent.status !== 'requires_confirmation') {
        // Shouldn't really be able to get here.
        this.initialLoading = false;
        this.showStripe = "";
        this.showError(data)
        return
      }
      try{
        let response = await this.apollo.mutate({
          mutation: gql`
              mutation payForRetailOrder($cartId: ID!, $paymentInfo: PaymentInfoInput!,$voucherCode: String) {
                payForRetailOrder (cartId: $cartId, paymentInfo: $paymentInfo, voucherCode: $voucherCode) {
                  order { id },
                  paymentDetails {
                      clientSecret,
                      requiresAction
                  }
                }
              }
            `,
          variables: {
            cartId: this.cartId,
            paymentInfo: {
              paymentIntentId: data.paymentIntent.id,
              address: this.details.shippingDetails
            },
            voucherCode: this.voucherCode || null
          }
        })

      const responseData = response.data.payForRetailOrder
      this.orderComplete(responseData.clientSecret, responseData.order.id)
      }catch(error){
        this.initialLoading = false;
        this.showStripe = "";     
        this.showError("Your card was declined.")
      }
    },
    asyncDialog (config) {
      return new Promise((resolve, reject) => {
        this.$q.dialog(config).onOk(resolve).onCancel(reject)
      })
    },
    shippingDetailsModified (address) {
      let accountAddress = store.getters['auth/getAccountAddress']
      return !Object.entries(address).every(([key, value]) => accountAddress?.[key] === value)
    },    
    async saveAddress (address) {
      this.updateAccount({ addresses: [address] })
    },
    updateAccount (input) {
      store.dispatch('auth/updateCurrentAccount', input).catch(err => {
        this.$q.notify({
          message: 'Error updating!',
          color: 'negative',
          icon: 'report_problem'
        })
      })
    },
    async pay (){
      this.clearError()      
      this.startProcessing()
      this.initialLoading = true;
      this.showStripe = "hidden";
      try {       
        const result = await stripe.createPaymentMethod('card',this.cardNumber);

        if (result.error) {
          this.initialLoading = false;
          this.showStripe = "";
          this.showError(result.error.message)
          return
        }

        //Process registration
        if(!(!!this.currentAccount) && this.isFormValid) {         
          let loginFormData = {
            contactName: this.details.registrationDetails.contactName,
            email: this.details.registrationDetails.email,
            password: this.details.registrationDetails.password,
            postCode: '0000',
            subscribeToEmails:this.details.registrationDetails.subscribeToEmails
          }
          //login
          await this.register(loginFormData);
          this.saveAddress(this.details.shippingDetails);
        }

        if (this.shippingDetailsModified(this.details.shippingDetails)) {
          try {
            await this.asyncDialog({
              title: 'Update Shipping Address',
              message: `Looks like you updated your shipping details.  Do you want to save the changes to your account?`,
              persistent: true,
              ok: { label: 'Save' },
              cancel: { label: 'Continue without saving', flat: true }
            })
            this.saveAddress(this.details.shippingDetails)
          } catch {
            //  Don't save
          }
        }


        
          //Send payment request to backend
          let response = await this.apollo.mutate({
            mutation: gql`
              mutation payForRetailOrder($cartId: ID!, $paymentInfo: PaymentInfoInput!, $voucherCode: String) {
                payForRetailOrder (cartId: $cartId, paymentInfo: $paymentInfo, voucherCode: $voucherCode) {
                  order { id },
                  paymentDetails {
                      clientSecret,
                      requiresAction
                  }
                }
              }
            `,
            variables: {
              cartId: this.cartId,
              paymentInfo: {
                paymentMethodId: result.paymentMethod.id,
                address: this.details.shippingDetails
              },
              voucherCode: this.voucherCode || null
            }
          })

          const paymentDetails = response.data.payForRetailOrder.paymentDetails
          if (paymentDetails.requiresAction) {
            // Request authentication
            this.handleAction(paymentDetails.clientSecret)
          } else {
            this.orderComplete(paymentDetails.clientSecret, response.data.payForRetailOrder.order.id)
          }
      }catch(error){
        this.initialLoading = false;
        this.showStripe = "";
        // TODO: Tidy this code
        if (error.networkError != null) {
          const networkError = error.networkError
          if (networkError.result != null && networkError.result.errors != null) {
            try {
              this.showError(networkError.result.errors.map(e => e.message.slice(e.message.lastIndexOf(';') + 2)).join('\n'))
            } catch {
              this.showError(networkError.result.errors.map(e => e.message).join('\n'))
            }
          } else {
            this.showError(networkError.message)
          }
        } else if (error.graphQLErrors != null) {
          this.showError(error.graphQLErrors[0].message)
        } else {
          this.showError(error.message)
        }
      } 
    },
  },
  created () {
      this.details.cartId = this.cartId;
      this.details.shippingDetails = {
      contactName: "",
      contactLastname: "",
      company: "",
      address: "",
      address2: "",
      phoneNumber: "",
      city: "",
      country: "",
      state: "",
      postCode: "",
      }
      this.details.registrationDetails = {
        contactName: '',
        email: '',
        password: '',
        postCode: '0000',
        agreeTAC: false,
        subscribeToEmails:false
      }
      if(!!this.currentAccount){
        this.details.shippingDetails = { ...store.getters['auth/getAccountAddress'] }
      }
      analytics.track('Checkout Popup Open')      

  },
  beforeDestroy () {
    this.cardNumber.destroy()
    this.cardExpiryDate.destroy()
    this.cardCVC.destroy()
  }

}
</script>


<style scoped lang="stylus">
  @import '~quasar-variables'


  .q-stepper{
     margin-top: -10px;
    @media (max-width: 600px){
      margin-left: -20px;
      margin-top: -30px;
      font-size: 12px;
      position: absolute;
      z-index:0;
    }
  }

  .mid-bar{
    margin:40px;
    display: flex;  
    justify-content: center;  
    align-items: center; 
    background-color:#e8e8e8; 
    max-width: 1px
  }

  .login{
    padding-right:20px;
    @media (max-width: 600px){
      padding:0px
    }
  }
  .register{
    padding: 0 20px
    text-align: center
    @media (max-width: 600px){
      padding-top:80px
      
    }
  }

  .cc-number{
    border: 2px solid silver;
    border-radius: 3px
    padding: 5px
    min-width: 130px
    text-align: center
  }

  .cc-date{
    border: 2px solid silver;
    border-radius: 3px
    padding: 5px
    text-align: center
  }

  .cc-code{
    border: 2px solid silver;
    border-radius: 3px
    padding: 5px
    text-align: center
  }

  #brand-icon{
    @media (max-width: 350px){
      display:none;
    }
  }

  >>> .q-stepper__dot:after{
      width: 0px
    }




</style>